<template>
  <el-main :style="{height:height+'px'}">
    <div class="Scroll_content">

      
      <div v-if="vip.length != 0">

        <div class="simkeropl">{{$t('MonthlyPassUser.Pass_Information')}}</div>
        
        <div class="sim_contents">
            <div class="simnder_imnmaa">
                <div class="slewij">
                    <div>
                        <span class="zitis">{{vip.title }}-{{vip.kids}} {{$t('MonthlyPassUser.kid')}}</span>
                    </div>
                    <div class="mg_top">
                        <span class="zitis">${{vip.price}}<span class="xiaozi">/{{$t('MonthlyPassUser.Month')}}</span></span>
                    </div>
                </div>
                <el-descriptions class="slewij" :column="1" direction="vertical">
                    <el-descriptions-item :label="$t('MonthlyPassUser.Pass_Expires')">{{vip.renew_at}}</el-descriptions-item>
                    <!-- <el-descriptions-item label="会员状态">{vip.member_status_name}</el-descriptions-item> -->
                    <el-descriptions-item :label="$t('MonthlyPassUser.Next_billing_date')">{{vip.member_expire_at}}</el-descriptions-item>
                    <!-- <el-descriptions-item label="会员暂停日期">{{vip.member_pause_date}}</el-descriptions-item> -->
                </el-descriptions>

                <div class="s4" @click="inde_rom">{{$t('MonthlyPassUser.view_billing_history')}}</div>
                <!-- <div class="slewij">
                    <div class="s1">{{$t('MonthlyPassUser.Next_billing_date')}}:</div>
                    <div class="s2">{{vip.renew_at}}</div>
                    <div class="s3" @click="rourt">{{$t('MonthlyPassUser.view_charges')}}</div>
                </div> -->
            </div>

        </div>

        <div class="sim_contents">
            <div class="mhg_contehs">
                <div class="wemitit flg">{{$t('MonthlyPassUser.Payment_method')}}：</div>
                
                <!-- <div class="danbosm flg"><img class="tupiam flg" src="../../assets/80713397.svg" alt="">{{user_pas.member_pay_method}}</div> -->
                <div class="danbosm flg" v-if="vip.member_pay_method_type=='1'"><img class="tupiam flg" src="../../assets/visa.svg" alt="">{{vip.member_pay_method_name}}</div>
                <div class="danbosm flg" v-if="vip.member_pay_method_type=='2'"><img class="alipay flg" src="../../assets/z5.svg" alt=""></div>
                <!-- <div class="gengxin flg">{{$t('MonthlyPassUser.Update')}}</div> -->
                <div class="wemitits flg" v-if="vip.member_pay_method_type=='1'">{{$t('MonthlyPassUser.Expires')}}: {{vip.renew_at}}</div>
            </div>
        </div>


        
        <div class="sim_contents">
            <div class="tpouslem">{{$t('MonthlyPassUser.Changing')}}</div>
            <div class="sim_son">
                <div class="flimgw_sihh">
                    
                    <img class="imgjs" src="../../assets/Ellipse395.svg" alt="">
                    <div class="mg_siyaaa">{{sale_info.name}}</div>
                    <div>({{sale_info.describe}})</div>
                </div>
                <div class="simm_whanhjaawx">
                    <div class="wen_Dax"><img class="m1" src="../../assets/Message (1).svg" alt="">{{sale_info.email}}</div>
                    <div class="wen_Dax"><img class="m1" src="../../assets/Strokeaa1.svg" alt="">{{sale_info.mobile}}</div>
                    <div class="wen_Dax"> <img class="m1" src="../../assets/WeChat_logo_icon 1.svg" alt=""> {{sale_info.wechat}}</div>
                </div>
                <div class="simm_whanhjaawx">
                    <img class="sikjj_tuxing" :src="sale_info.qr_code" alt="">
                </div>
                
            </div>
        </div>
        <div class="dian mgb"></div>
      </div>    
      

      <el-empty v-else description="您还不是会员，请购买之后再进行查看哦！"></el-empty>    

    </div>
  </el-main>
  
</template>
<script>
  import { setStore, getStore, keys } from '@/store';
  import IndexHeader from '../views/header'
  import IndexFooter from '../views/footer'
  import MyScheduled from '../views/scheduled'
  import MyCourse from '../views/course'
  import PastLesson from '../views/lesson'

  //引入header组件
  import Header from '../header/header'

  export default {
    components: {
      IndexHeader,
      IndexFooter,
      MyScheduled,
      PastLesson,
      MyCourse,
      Header
    },
    data () {
      return {
          height:100,
          vip:[],
          sale_info:[],
          user_pas:[]
      }
    },
    created () {
      let height = document.body.offsetHeight-80;
      this.height = height;
    if (getStore(keys.token)) {
        if (getStore(keys.userInfo).status == 0) {
          this.$router.push({
            path: '/sinadd'
          })
        }
      } else {
        this.$router.push({
          path: '/'
        })
        return false
      }
      this.My_meal();
      this.Sales_information();
    },
    methods: {
        /**
         * 获取我的套餐方法
         */
        My_meal(){
            this.$http.get('/api/getMyPlanList').then((res) => {
            if (res.data.code == 200) {
                console.log(121212121,res)
                this.vip = res.data.data
            } else {
                this.$message({
                message: res.data.msg,
                type: 'warning'
                })
            }
            }).catch((error) => {
            console.log(error) // 请求失败返回的数据
            })
        },
        /**
         * 获取销售信息
         */
        Sales_information:function(){
            // let _lan = (navigator.language == 'zh-CN')?'zh_CN': 'en'
            this.$http.get('/api/getUserInfo', {headers: {token:getStore(keys.token)}}).then((res) => {
            if (res.data.code == 200) {
                console.log(res)
                setStore(keys.user, res.data.data)
                this.sale_info = res.data.data.salesperson_info;
                this.user_pas = res.data.data.user_info;
            } else {
                this.$message({
                message: res.data.msg,
                type: 'warning'
                })
            }
            }).catch((error) => {
            console.log(error) // 请求失败返回的数据
            })
        },
        /**
         * 跳转费用记录
         */
        rourt:function(){
            this.$router.push({ path: "/home/children/MonthyuStatement" });
        },
        /**
         * 跳转支付记录
         */
        inde_rom:function(){
            this.$router.push({ path: "/home/children/Transaction" });
        }
    },
    mounted () {

    },
    watch: {

    },
  }
</script>
<style lang="less" scoped>
.simkeropl{
    // font-family: Sofia Pro;
    font-style: normal;
    font-weight: 700;
    font-size: 33px;
    color: #000000;
    // text-align: center;
    margin-bottom:35px;
    margin-top:45px;
}
.sim_contents{
    width: 100%;
    padding:20px 33px;
    // height: 275px;
    background: #FFFFFF;
    border: 1px solid #E8E8E8;
    box-sizing: border-box;
    border-radius: 5px;
    margin-bottom:36px;
    .simnder_imnmaa{
        width: 95%;
        // border-bottom:1px solid rgba(0, 0, 0, 0.1);
        // margin:38px auto 0 auto;
        // display: flex;
        .slewij{
            flex: 1;
            .zitis{
                // font-family: Sofia Pro;
                font-style: normal;
                font-weight: 700;
                font-size: 24px;
                color: #000000;
                letter-spacing: -0.02em;
                .xiaozi{
                    font-weight: normal;
                    font-size:20px;
                }
            }
        }
        /deep/ .el-descriptions{
            margin-top:20px;
            .el-descriptions-item__label{
                font-weight: 400;
                font-size: 20px;
                letter-spacing: -0.02em;
                color: #111827;
            }
            .el-descriptions-item__content{
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;

                color: #6B7280;
            }
        }
    }
    .mhg_contehs{
        // width: 914px;
        // width:95%;
        // height: 100px;
        .wemitit{
            font-family: Sofia Pro;
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            letter-spacing: -0.02em;
            color: #111827;
            margin-bottom:20px;
        }
        .danbosm{
            font-style: normal;
            font-weight: 400;
            font-size: 20px;
            letter-spacing: -0.02em;
            color: #111827;
            margin-top:8px;
        }
        .gengxin{
            font-family: Sofia Pro;
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 100%;
            /* or 14px */
            text-decoration-line: underline;
            color: #000000;
            margin-top: 3px;
            margin-left: 25px;
            cursor: pointer;
        }
        .tupiam{
            width: 26px;
            height: 14px;
            margin-top: 3px;
            margin-right: 10px;
        }
        .alipay{
            width:68px;
        }
    }
}
.sol{
    color: #4B69FE !important;
}
.rol{
    color: #4B69FE !important;
}
.mg_top{
    margin-top:15px;
}
.s1{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 18px;
    /* identical to box height, or 100% */

    text-align: right;

    color: #000000;
}
.s2{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 23px;
    line-height: 22px;
    /* identical to box height, or 96% */

    text-align: right;
    margin-top:14px;
    color: #4B69FE;
}
.s3{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 14px;
    /* identical to box height, or 109% */
    margin-top:12px;
    text-align: right;
    text-decoration-line: underline;
    cursor: pointer;
    color: #4B69FE;
}
.s4{
    // font-family: Sofia Pro;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 14px;
    /* identical to box height, or 109% */
    cursor: pointer;
    // text-align: right;
    text-decoration-line: underline;
    margin-top:15px;
    color: #4B69FE;
}
.flg{
    // float: left;
}
.wemitits{
    // font-family: Sofia Pro;
    // font-style: normal;
    // font-weight: normal;
    font-size: 16px;
    color: #6B7280;
    margin-top:8px;
}
.msija{
    margin-top:0px !important;
}
.tpouslem{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    color: #000000;
}
.sim_contents{
    .sim_son{
        display: flex;
        align-items: center;
        justify-content: space-between;
        // width: 914px;
        // height: 170px;
        // margin: 24px auto 0 auto;
        .imgjs{
            // margin-top:18px;
            width: 57px;
            height: 57px;
        }
        .flimgw_sihh{
            // margin-left: 17px;
            // margin-top:30px;
            font-size: 18px;
            text-align: center;
            .mg_siyaaa{
                font-family: Sofia Pro;
                font-style: normal;
                font-weight: 600;
                font-size: 20px;
                line-height: 18px;
                margin:5px 0;
                color: #0B1D33;
            }
        }
        .simm_whanhjaawx{
            .wen_Dax{
                display: flex;
                font-style: normal;
                font-weight: 600;
                font-size: 18px;
                line-height: 40px;
                /* identical to box height, or 93% */
                color: #0B1D33;
            }
        }
        .sikjj_tuxing{
            width:146px;
            height:146px;
            border:3px solid #4B69FE;
            border-radius: 5px;
            // margin-top: 15px;
        }
    }
}
.m1{
    // position: relative;
    // top: 3px;
    margin-right: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/children/MonthlyPassUser.vue